import React, { useEffect } from "react"
import RoomCard from "../home/room/RoomCard"
import "../home/room/room.scss"
import PageHeader from "../common/pageHeader/PageHeader"
import { useTranslation } from 'react-i18next'
import APPLICATIONS from "../data/Applications"

const Rooms = () => {
  const applicationId = APPLICATIONS[0].id
  const { t } = useTranslation('rooms')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <section className='blog-out mb'>
        <PageHeader
          label={t('Our rooms') as string}
          title={t('Our cozy rooms') as string}
          subtitle={t('Each room bears the name of a Sologne flower. Each stay is a parenthesis of grace.', { ns: 'home' }) as string}
        />
        <div className='container room rooms-page mtop'>
          <RoomCard applicationId={applicationId} />
        </div>
      </section>
    </>
  )
}

export default Rooms
